import { useEffect } from 'react';
import Section from '../../components/base/Section';
import Button from '../../components/base/Button';

export default function ServiciosPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Servicios de Vaciado y Limpieza Granollers | JUSTCLEAN';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Vaciado de pisos, locales, retirada de muebles, limpieza Diógenes, pintura y reparaciones en Granollers. Servicio profesional 24h en Vallès Oriental ☎ 602 36 59 96');
    }

    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', 'servicios vaciado Granollers, limpieza Diógenes, retirada muebles, pintura, reparaciones');
    }

    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', `${import.meta.env.VITE_SITE_URL || 'https://granollers.justclean.es'}/servicios`);
    }

    // Schema.org JSON-LD - Service
    const schemaScript = document.createElement('script');
    schemaScript.type = 'application/ld+json';
    schemaScript.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "ItemList",
      "name": "Servicios de Vaciado y Limpieza en Granollers",
      "description": "Servicios profesionales de vaciado de pisos, limpieza extrema y más en Granollers",
      "url": `${import.meta.env.VITE_SITE_URL || 'https://granollers.justclean.es'}/servicios`,
      "itemListElement": [
        {
          "@type": "ListItem",
          "position": 1,
          "item": {
            "@type": "Service",
            "name": "Vaciado de Pisos y Casas",
            "description": "Servicio completo de vaciado de pisos, casas y viviendas en Granollers y Vallès Oriental",
            "provider": {
              "@type": "LocalBusiness",
              "name": "JUSTCLEAN GRANOLLERS"
            },
            "areaServed": "Granollers, Vallès Oriental"
          }
        },
        {
          "@type": "ListItem",
          "position": 2,
          "item": {
            "@type": "Service",
            "name": "Vaciado de Locales Comerciales",
            "description": "Especialistas en vaciado de locales comerciales, oficinas y naves industriales",
            "provider": {
              "@type": "LocalBusiness",
              "name": "JUSTCLEAN GRANOLLERS"
            },
            "areaServed": "Granollers, Vallès Oriental"
          }
        },
        {
          "@type": "ListItem",
          "position": 3,
          "item": {
            "@type": "Service",
            "name": "Retirada de Muebles y Electrodomésticos",
            "description": "Servicio especializado de recogida y transporte de muebles y electrodomésticos",
            "provider": {
              "@type": "LocalBusiness",
              "name": "JUSTCLEAN GRANOLLERS"
            },
            "areaServed": "Granollers, Vallès Oriental"
          }
        },
        {
          "@type": "ListItem",
          "position": 4,
          "item": {
            "@type": "Service",
            "name": "Limpieza Síndrome de Diógenes",
            "description": "Especialistas en limpieza por síndrome de Diógenes y situaciones de suciedad extrema",
            "provider": {
              "@type": "LocalBusiness",
              "name": "JUSTCLEAN GRANOLLERS"
            },
            "areaServed": "Granollers, Vallès Oriental"
          }
        },
        {
          "@type": "ListItem",
          "position": 5,
          "item": {
            "@type": "Service",
            "name": "Pintura Final y Acabados",
            "description": "Servicio de pintura y acabados finales tras el vaciado de pisos y locales",
            "provider": {
              "@type": "LocalBusiness",
              "name": "JUSTCLEAN GRANOLLERS"
            },
            "areaServed": "Granollers, Vallès Oriental"
          }
        },
        {
          "@type": "ListItem",
          "position": 6,
          "item": {
            "@type": "Service",
            "name": "Pequeñas Reparaciones",
            "description": "Servicio de pequeñas reparaciones y mantenimiento básico",
            "provider": {
              "@type": "LocalBusiness",
              "name": "JUSTCLEAN GRANOLLERS"
            },
            "areaServed": "Granollers, Vallès Oriental"
          }
        }
      ]
    });
    document.head.appendChild(schemaScript);

    // Manejar hash de navegación
    if (window.location.hash) {
      setTimeout(() => {
        const element = document.querySelector(window.location.hash);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }

    return () => {
      if (schemaScript.parentNode) {
        schemaScript.parentNode.removeChild(schemaScript);
      }
    };
  }, []);

  const services = [
    {
      id: 'vaciado-pisos',
      icon: 'ri-home-4-line',
      title: 'Vaciado de pisos y casas en Granollers',
      image: 'https://public.readdy.ai/ai/img_res/924de756f8578dd59e21bab4e7afd651.jpg',
      description: 'Servicio completo de vaciado de pisos, casas y viviendas en Granollers, Canovelles, Les Franqueses del Vallès y toda la comarca del Vallès Oriental. Nos encargamos de retirar todos los enseres, muebles, electrodomésticos y objetos personales, dejando el inmueble completamente vacío y listo para su siguiente uso.',
      benefits: [
        'Vaciado completo de pisos heredados en Granollers',
        'Retirada de todo tipo de muebles y enseres',
        'Limpieza final incluida tras el vaciado',
        'Gestión legal de residuos y reciclaje',
        'Servicio urgente disponible 24 horas',
        'Presupuesto sin compromiso en menos de 24h',
        'Coordinación con comunidades de vecinos',
        'Seguro de responsabilidad civil incluido'
      ],
      cases: 'Ideal para herencias, mudanzas, desahucios, divorcios, vaciado de trasteros en Granollers, preparación de pisos para venta o alquiler en Vallès Oriental.'
    },
    {
      id: 'vaciado-locales',
      icon: 'ri-store-2-line',
      title: 'Vaciado de locales comerciales',
      image: 'https://readdy.ai/api/search-image?query=empty%20commercial%20space%20retail%20store%20clean%20white%20walls%20open%20floor%20bright%20lighting%20business%20premises&width=800&height=600&seq=servicio-locales-001&orientation=landscape',
      description: 'Especialistas en vaciado de locales comerciales, oficinas, naves industriales y espacios de negocio en Granollers y Vallès Oriental. Retiramos mobiliario de oficina, estanterías, mostradores, maquinaria ligera y todo tipo de equipamiento comercial con total profesionalidad.',
      benefits: [
        'Vaciado de locales comerciales en Granollers',
        'Retirada de mobiliario de oficina y comercial',
        'Desmontaje de estanterías y mostradores',
        'Gestión de residuos comerciales e industriales',
        'Servicio fuera de horario comercial disponible',
        'Mínima interrupción de la actividad',
        'Coordinación con propietarios y arrendatarios',
        'Certificado de gestión de residuos'
      ],
      cases: 'Perfecto para cierre de negocios, traspasos de locales en Granollers, cambios de actividad comercial, reformas de oficinas en Vallès Oriental, liquidación de stocks.'
    },
    {
      id: 'retirada-muebles',
      icon: 'ri-truck-line',
      title: 'Retirada de muebles y electrodomésticos',
      image: 'https://readdy.ai/api/search-image?query=professional%20movers%20loading%20furniture%20appliances%20truck%20organized%20removal%20service%20workers%20carrying%20sofa%20refrigerator&width=800&height=600&seq=servicio-muebles-001&orientation=landscape',
      description: 'Servicio especializado de recogida y transporte de muebles, electrodomésticos y enseres voluminosos en Granollers, Parets del Vallès, Montmeló y toda la comarca. Retiramos sofás, armarios, camas, neveras, lavadoras, televisores y cualquier objeto que necesites eliminar de tu hogar o negocio.',
      benefits: [
        'Recogida de muebles y electrodomésticos en Granollers',
        'Transporte y carga incluidos en el servicio',
        'Retirada de enseres voluminosos y pesados',
        'Reciclaje responsable de electrodomésticos',
        'Servicio rápido en 24-48 horas',
        'Sin necesidad de bajar los muebles tú mismo',
        'Equipo profesional con experiencia',
        'Precios competitivos en Vallès Oriental'
      ],
      cases: 'Ideal para renovación de mobiliario, compra de electrodomésticos nuevos, vaciado parcial de viviendas en Granollers, eliminación de enseres tras mudanza.'
    },
    {
      id: 'limpieza-diogenes',
      icon: 'ri-heart-pulse-line',
      title: 'Limpieza por síndrome de Diógenes y suciedad extrema',
      image: 'https://readdy.ai/api/search-image?query=professional%20deep%20cleaning%20service%20workers%20protective%20equipment%20sanitizing%20disinfection%20process%20cleaning%20team&width=800&height=600&seq=servicio-diogenes-001&orientation=landscape',
      description: 'Somos especialistas en limpieza por síndrome de Diógenes y situaciones de suciedad extrema en Granollers y Vallès Oriental. Actuamos con máxima discreción, empatía y profesionalidad en casos delicados que requieren sensibilidad especial. Nuestro equipo está formado y equipado para afrontar cualquier situación de acumulación compulsiva.',
      benefits: [
        'Especialistas en síndrome de Diógenes en Granollers',
        'Máxima discreción y respeto en todo momento',
        'Equipo formado en situaciones delicadas',
        'Limpieza profunda y desinfección completa',
        'Retirada de acumulación de objetos y residuos',
        'Coordinación con servicios sociales',
        'Tratamiento de olores y desinfección',
        'Apoyo psicológico y trato empático'
      ],
      cases: 'Esencial para casos de acumulación compulsiva, síndrome de Diógenes en Granollers, limpieza tras situaciones de abandono, coordinación con servicios sociales del Vallès Oriental.'
    },
    {
      id: 'pintura',
      icon: 'ri-paint-brush-line',
      title: 'Pintura final y acabados',
      image: 'https://readdy.ai/api/search-image?query=professional%20painter%20painting%20white%20walls%20empty%20apartment%20clean%20finish%20roller%20brush%20fresh%20paint%20bright%20room&width=800&height=600&seq=servicio-pintura-001&orientation=landscape',
      description: 'Servicio de pintura y acabados finales tras el vaciado de pisos y locales en Granollers. Dejamos las paredes, techos y espacios perfectamente pintados y listos para alquilar o vender. Utilizamos pinturas de calidad y ofrecemos acabados profesionales que revalorizan tu inmueble.',
      benefits: [
        'Pintura completa de pisos en Granollers',
        'Preparación de superficies y alisado',
        'Pinturas de calidad y acabado profesional',
        'Pintura de paredes, techos y carpintería',
        'Colores neutros ideales para venta/alquiler',
        'Servicio rápido tras el vaciado',
        'Presupuesto cerrado sin sorpresas',
        'Garantía de acabado perfecto'
      ],
      cases: 'Perfecto para preparar pisos para venta en Granollers, renovación antes de alquilar, mejora estética tras vaciado, revalorización de inmuebles en Vallès Oriental.'
    },
    {
      id: 'reparaciones',
      icon: 'ri-tools-line',
      title: 'Pequeñas reparaciones y mantenimiento',
      image: 'https://readdy.ai/api/search-image?query=handyman%20doing%20repairs%20apartment%20fixing%20door%20handle%20wall%20patch%20maintenance%20professional%20worker%20tools%20home%20improvement&width=800&height=600&seq=servicio-reparaciones-001&orientation=landscape',
      description: 'Servicio de pequeñas reparaciones y mantenimiento básico en Granollers y comarca. Solucionamos desperfectos menores, arreglamos puertas, ventanas, grifos, enchufes y cualquier detalle que necesite atención antes de entregar el inmueble. Dejamos todo en perfectas condiciones.',
      benefits: [
        'Reparaciones menores en pisos de Granollers',
        'Arreglo de puertas, ventanas y cerraduras',
        'Reparación de grifos y pequeñas fugas',
        'Arreglo de enchufes e interruptores',
        'Sellado de juntas y pequeñas grietas',
        'Cambio de bombillas y pequeños accesorios',
        'Servicio complementario al vaciado',
        'Entrega del inmueble en perfecto estado'
      ],
      cases: 'Ideal para preparación final de pisos en Granollers, arreglos previos a inspecciones, solución de desperfectos menores, mantenimiento básico en Vallès Oriental.'
    }
  ];

  return (
    <main className="overflow-x-hidden">
      {/* Hero */}
      <section className="relative h-[50vh] flex items-center justify-center overflow-hidden pt-20 pb-12 sm:pb-16 md:pb-20">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=professional%20cleaning%20services%20collage%20various%20activities%20team%20working%20modern%20equipment%20organized%20workers%20bright%20spaces&width=1920&height=800&seq=servicios-hero-001&orientation=landscape')`
          }}
        >
          <div className="absolute inset-0 bg-gradient-to-b from-black/60 to-black/40"></div>
        </div>

        <div className="relative z-10 container mx-auto px-4 max-w-7xl text-center text-white py-8 sm:py-12">
          <nav className="text-sm mb-4 sm:mb-6 opacity-90">
            <a href="/" className="hover:text-primary transition-colors cursor-pointer">Inicio</a>
            <span className="mx-2">&gt;</span>
            <span>Servicios</span>
          </nav>
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold mb-4 sm:mb-6 px-4 leading-tight">
            Servicios de vaciado y limpieza en Granollers
          </h1>
          <p className="text-base sm:text-lg md:text-xl text-white/90 max-w-3xl mx-auto px-4 leading-relaxed">
            Soluciones completas de vaciado de pisos, locales, limpieza extrema y servicios complementarios en Granollers y Vallès Oriental. Conoce más sobre <a href="/empresa" className="underline hover:text-primary transition-colors cursor-pointer">nuestra empresa</a>.
          </p>
        </div>
      </section>

      {/* Servicios Detallados */}
      {services.map((service, index) => (
        <Section 
          key={service.id} 
          background={index % 2 === 0 ? 'white' : 'light'} 
          padding="lg"
          id={service.id}
        >
          <div className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${
            index % 2 === 1 ? 'lg:flex-row-reverse' : ''
          }`}>
            {/* Texto */}
            <div className={index % 2 === 1 ? 'lg:order-2' : ''}>
              <div className="w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mb-6 flex-shrink-0">
                <i className={`${service.icon} text-4xl text-primary`}></i>
              </div>
              
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-secondary mb-6 break-words">
                {service.title}
              </h2>
              
              <p className="text-base sm:text-lg text-tertiary leading-relaxed mb-6 break-words">
                {service.description}
              </p>

              <h3 className="text-lg sm:text-xl font-bold text-secondary mb-4">
                ¿Qué incluye este servicio?
              </h3>
              <ul className="space-y-3 mb-6">
                {service.benefits.map((benefit, idx) => (
                  <li key={idx} className="flex items-start gap-3">
                    <i className="ri-checkbox-circle-fill text-primary text-xl mt-1 flex-shrink-0 w-5 h-5 flex items-center justify-center"></i>
                    <span className="text-tertiary text-sm sm:text-base break-words">{benefit}</span>
                  </li>
                ))}
              </ul>

              <div className="bg-primary/5 border-l-4 border-primary p-4 rounded-r-lg mb-6">
                <p className="text-sm text-secondary break-words">
                  <strong>Casos de uso:</strong> {service.cases}
                </p>
              </div>

              <Button 
                variant="primary"
                onClick={() => window.location.href = '/contacto'}
                icon={<i className="ri-send-plane-line"></i>}
              >
                Solicitar Este Servicio
              </Button>
            </div>

            {/* Imagen */}
            <div className={`${index % 2 === 1 ? 'lg:order-1' : ''} w-full h-[400px] sm:h-[500px] lg:h-[600px]`}>
              <img 
                src={service.image}
                alt={service.title}
                className="rounded-2xl shadow-2xl w-full h-full object-cover"
                loading="lazy"
                decoding="async"
              />
            </div>
          </div>
        </Section>
      ))}

      {/* Casos de Uso */}
      <Section background="light" padding="lg">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-secondary mb-4">
            Situaciones en las que podemos ayudarte
          </h2>
          <p className="text-lg text-tertiary max-w-3xl mx-auto">
            Nuestros servicios de vaciado y limpieza en Granollers son la solución perfecta para múltiples situaciones. Si tienes dudas, visita nuestra sección de <a href="/faq" className="text-primary underline hover:text-secondary cursor-pointer">preguntas frecuentes</a>.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {[
            { icon: 'ri-parent-line', title: 'Herencias', desc: 'Vaciado de pisos heredados en Granollers con total respeto' },
            { icon: 'ri-truck-line', title: 'Mudanzas', desc: 'Retirada de enseres que no te llevas a tu nuevo hogar' },
            { icon: 'ri-building-line', title: 'Cierre de Negocios', desc: 'Vaciado de locales comerciales en Vallès Oriental' },
            { icon: 'ri-home-heart-line', title: 'Divorcios', desc: 'Vaciado discreto de viviendas compartidas' },
            { icon: 'ri-auction-line', title: 'Desahucios', desc: 'Limpieza y vaciado tras procesos de desahucio' },
            { icon: 'ri-paint-brush-line', title: 'Reformas', desc: 'Vaciado previo a reformas integrales en Granollers' },
            { icon: 'ri-heart-pulse-line', title: 'Síndrome de Diógenes', desc: 'Limpieza extrema con máxima discreción' },
            { icon: 'ri-key-line', title: 'Venta/Alquiler', desc: 'Preparación de inmuebles para venta o alquiler' },
            { icon: 'ri-recycle-line', title: 'Reciclaje', desc: 'Gestión responsable de residuos y reciclaje' }
          ].map((caso, index) => (
            <div key={index} className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-shadow duration-300">
              <div className="w-14 h-14 rounded-full bg-primary/10 flex items-center justify-center mb-4">
                <i className={`${caso.icon} text-3xl text-primary`}></i>
              </div>
              <h3 className="text-lg font-bold text-secondary mb-2">{caso.title}</h3>
              <p className="text-sm text-tertiary">{caso.desc}</p>
            </div>
          ))}
        </div>
      </Section>

      {/* CTA Final */}
      <Section background="gradient" padding="lg">
        <div className="text-center max-w-3xl mx-auto">
          <h2 className="text-4xl font-bold mb-6">
            ¿Qué servicio necesitas en Granollers?
          </h2>
          <p className="text-xl mb-8 text-white/90">
            Contacta con nosotros y te asesoramos sin compromiso. Presupuesto gratuito en menos de 24 horas.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              variant="white"
              size="lg"
              onClick={() => window.location.href = 'tel:+34602365996'}
              icon={<i className="ri-phone-line"></i>}
            >
              Llamar 602 36 59 96
            </Button>
            <Button 
              variant="outline"
              size="lg"
              onClick={() => window.location.href = '/contacto'}
              icon={<i className="ri-mail-line"></i>}
              className="border-white text-white hover:bg-white hover:text-primary"
            >
              Solicitar Presupuesto
            </Button>
          </div>
        </div>
      </Section>
    </main>
  );
}
